'use client'

import ParsedHtmlContent from "@/components/etc/renderContent";
import { useNav } from "@/context/navContext";
import { SettingContext } from "@/context/siteContext";
import logo_mo_footer from "@/public/image/logo/logo_mo.png"
import { useContext, useEffect, useState } from "react"

export default function FooterMo(){
    const { setting } = useContext(SettingContext);
    const { movePage } = useNav()

    useEffect(() => {
        // console.log("setting 1 :", setting?.objects[1].content);
        // console.log("setting 2 :", setting?.objects[2].content);
    }, [])
    return (
        <footer id="footer">
            <div>
                {/* <img src={logo_mo_footer.src} alt="logo footer" /> */}
                <div className={`pageLogoArea`}  onClick={()=>{movePage("/")}}></div>
                <div>
                    {setting?.objects[1].is_active && <div><ParsedHtmlContent html={setting?.objects[1].content || ""} /></div>}
                    {setting?.objects[2].is_active && <div className={`m-t-15`}><ParsedHtmlContent html={setting?.objects[2].content || ""} /></div>}
                </div>
            </div>
        </footer>
    )
}  